export const EVENT = 'event'
export const PRODUCT = 'product'

export default {
  [EVENT]: 'Event',
  [PRODUCT]: 'Product'
}
